import { useSizeClass } from "../../common/Utils/useSizeClass";
import { SizeClass } from "@/src/common/Utils/SizeClass";

import { CreateStoreComponent } from "../StoreCreate/CreateStoreComponent";
import React from "react";
import { View } from "react-native";
import { useKeyboard } from "../../OS/useKeyboard";
import { ProfileStackScreenProps } from "./ProfileStack";

export const ProfileCreateStoreScreen: React.FC<
  ProfileStackScreenProps<"CreateStore">
> = (props) => {
  const keyboard = useKeyboard();
  const isCompact = useSizeClass().width === SizeClass.COMPACT;
  return (
    <View
      style={{
        flex: 1,
        paddingBottom: isCompact ? keyboard.availableRect.bottom : 0,
      }}
    >
      <CreateStoreComponent
        onCreatedStore={() => {
          props.navigation.replace("Home", { hasOrg: false });
        }}
      />
    </View>
  );
};
